import React, { PureComponent } from "react";
import OneColumnLayout from "../../layouts/one-column";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import Teams from "../../../../api/Teams";

class TeamReportsSection5Step3 extends PureComponent {
  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    return data[team_id][key] || 0;
  };

  get content() {
    const team = Teams.currentTeam();
    const team_id = team ? team.id : 0;
    const unitsProduced = this.getDataValue(team_id, "Units Produced");
    let {
      avgMaterialCostsPerUnit,
      avgLaborCostsPerUnit,
      avgOverheadCostsPerUnit
    } = this.props;

    avgMaterialCostsPerUnit /= unitsProduced;
    avgLaborCostsPerUnit /= unitsProduced;
    avgOverheadCostsPerUnit /= unitsProduced;

    avgMaterialCostsPerUnit = Number(avgMaterialCostsPerUnit.toFixed(2));
    avgLaborCostsPerUnit = Number(avgLaborCostsPerUnit.toFixed(2));
    avgOverheadCostsPerUnit = Number(avgOverheadCostsPerUnit.toFixed(2));

    if (!isFinite(avgMaterialCostsPerUnit)) {
      avgMaterialCostsPerUnit = 0;
    }

    if (!isFinite(avgLaborCostsPerUnit)) {
      avgLaborCostsPerUnit = 0;
    }

    if (!isFinite(avgOverheadCostsPerUnit)) {
      avgOverheadCostsPerUnit = 0;
    }

    const avgProductsUnitCosts = (
      avgMaterialCostsPerUnit +
      avgLaborCostsPerUnit +
      avgOverheadCostsPerUnit
    ).toFixed(2);

    return (
      <span>
        Direct Materials, Labor, and Overhead drives your product costs. The
        costs below is a breakdown of the average unit costs of all your
        products.
        <div className="team-reports-operational-analysis">
          <table>
            <tbody>
              <tr>
                <td className="price">${avgMaterialCostsPerUnit.toFixed(2)}</td>
                <td>+</td>
                <td className="price">${avgLaborCostsPerUnit.toFixed(2)}</td>
                <td>+</td>
                <td className="price">${avgOverheadCostsPerUnit.toFixed(2)}</td>
                <td>=</td>
                <td className="price">${avgProductsUnitCosts}</td>
              </tr>
              <tr>
                <td className="price-description">
                  Material
                  <br />
                  Costs Per Unit
                </td>
                <td />
                <td className="price-description">
                  Labor
                  <br />
                  Costs Per Unit
                </td>
                <td />
                <td className="price-description">
                  Overhead
                  <br />
                  Costs Per Unit
                </td>
                <td />
                <td className="price-description">
                  Product's
                  <br />
                  Unit Costs
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        To learn more about what impacts these Operating Expenses, please review
        the following content:
        <br />
        <TypeformLink title="Product Costs" url={TypeformUrls.PRODUCT_COSTS} />
      </span>
    );
  }

  render() {
    return (
      <OneColumnLayout title="Operational Analysis" content={this.content} />
    );
  }
}

export default TeamReportsSection5Step3;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-5/step-3.js